<template>
    <div>
        <swiper class="swiper mb-3 product-gallery" ref="gallery" :options="swiperGallery" @slideChange="onSlideChange">
            <swiper-slide v-for="(item, index) in productGallery" :key="`item${index}`">
                <div class="aspect-ratio" :class="getClassAspectRatio">
                    <div class="aspect-content">
                        <template v-if="item.type === 'image'">
                            <img :src="imageUrl(item.image)" :alt="item.description" :title="item.description"
                                 class="cursor-zoom-in"
                                 :class="$wdconfig.modules.product.image_object_fit"
                                 @click="lightboxIndex = index"
                            >
                        </template>
                        <template v-if="item.type === 'iframe'">
                            <iframe width="100%" height="100%" :src="item.url" :title="item.name"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen></iframe>
                        </template>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination d-md-none" slot="pagination"></div>
            <div class="swiper-button-prev mx-2" slot="button-prev">
                <svg width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M14 5l-7 7 7 7"/>
                </svg>
            </div>
            <div class="swiper-button-next mx-2" slot="button-next">
                <svg width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10 5l7 7-7 7"/>
                </svg>
            </div>
        </swiper>
        <swiper class="swiper d-none d-md-block" :options="thumbs">
            <swiper-slide v-for="(item, index) in productGallery" :key="`thumb${index}`" class="mx-2">
                <div class="product-gallery-thumb" @click="changeSlide(index)">
                    <div class="aspect-ratio" :class="getClassAspectRatio">
                        <div class="aspect-content">
                            <template v-if="item.type === 'image'">
                                <img :src="imageUrl(item.image)" :alt="item.description" :title="item.description"
                                     :class="$wdconfig.modules.product.image_object_fit">
                            </template>
                            <template v-if="item.type === 'iframe'">
                                <img :src="imageUrl(item.image)" :alt="item.name" :title="item.name"
                                     :class="$wdconfig.modules.product.image_object_fit">
                            </template>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>

        <CoolLightBox
            :items="productGallery"
            :index="lightboxIndex"
            :fullScreen="true"
            :useZoomBar="true"
            :slideshow="false"
            @close="lightboxIndex = null"
        />
    </div>
</template>

<script>
    import utils from '~/mixins/utils'
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        components: {
            CoolLightBox
        },
        mixins: [
            utils
        ],
        props: {
            gallery: {
                type: Array,
                default: []
            },
            videos: {
                type: Array,
                default: []
            },
            name: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                swiperGallery: {
                    lazy: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                thumbs: {
                    slidesPerView: 5
                },
                lightboxIndex: null
            }
        },
        computed: {
            productGallery() {
                let list = []
                this.gallery.forEach(el => {
                    el['type'] = 'image'
                    el['src'] = this.imageUrl(el['image'])
                    el['alt'] = el['description']
                    el['description'] = el['description']
                    el['title'] = el['description']
                    list.push(el)
                })
                this.videos.forEach(el => {
                    el['type'] = 'iframe'
                    let video = this.getVideo(el)
                    if (video) {
                        list.push(video)
                    }
                })
                if (list.length <= 0) {
                    list.push({
                        type: 'image',
                        image: 'index.php?type=img&id=MA==',
                        src: this.imageUrl('index.php?type=img&id=MA=='),
                        alt: '',
                        title: '',
                        description: ''
                    })
                }
                return list
            }
        },
        methods: {
            changeSlide(index) {
                this.$refs.gallery.$swiper.slideTo(index)
            },
            onSlideChange() {
                document.querySelectorAll('.product-gallery iframe').forEach(v => {
                    try {
                        v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    } catch (e) {
                        console.error(e)
                    }
                });
            },
            getVideo(obj) {
                try {
                    if (/((?:www|m)\.)?((?:youtube\.com|youtu.be))/.test(obj.url)) {
                        let url = obj.url
                        url = obj.url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|\/shorts\/|youtu\.be\/|\/embed\/)/);
                        if (url[2] !== undefined) {
                            let id = url[2].split(/[^0-9a-z_\-]/i)[0];
                            obj.url = 'https://www.youtube.com/embed/' + id + '?showinfo=0&version=3&enablejsapi=1'
                            obj.title = obj.name
                            obj.src = obj.url
                            obj.image = 'https://img.youtube.com/vi/' + id + '/0.jpg'
                            obj.thumb = obj.image
                            return obj
                        }
                    }
                } catch (e) {
                    console.error(e)
                }
                return false
            }
        }
    }
</script>
